import React from 'react';
import { fetchJson } from '../api';
import { useGlobalStore } from '../store/global';
import { getTemplateData } from "../utils";
export default function GlobalSettings({ templateData }) {
    const globalSettingAPI = getTemplateData('data-global-api', templateData);
    const set = useGlobalStore((state) => state.set);
    React.useEffect(() => {
        async function fn() {
            try {
                const data = await fetchJson(globalSettingAPI);
                set(data);
            }
            catch (e) {
                console.error(e);
            }
        }
        fn();
    }, []);
    return null;
}
export function useGlobalSettings(fn) {
    const config = useGlobalStore((state) => state.config);
    const isInited = useGlobalStore((state) => state.isInited);
    const [fnInited, setFnInited] = React.useState(false);
    React.useEffect(() => {
        async function fn2() {
            if (isInited) {
                try {
                    await fn(config);
                    setFnInited(true);
                }
                catch (err) {
                    console.error(err);
                }
            }
        }
        fn2();
    }, [isInited]);
    return {
        isInited: fnInited,
    };
}
